module.exports = __webpack_public_path__ + "static/public1-b88a543a6346fd21cdc24b55eb547792.png";